import React from "react";
import "./News.css";
import twins from "../../../../assets/img/twins.jpg";
import research from "../../../../assets/img/research.jpg";
import writing from "../../../../assets/img/writing.jpeg";
import { Link } from "react-router-dom";

const News = () => {
	return (
		<div className='uiowa-news'>
			<div className='content'>
				<h1 className='title'>News and features</h1>
				<div className='news-link mb-5'>
					<Link className='d-flex align-items-center  gap-3'>
						READ CAMPUS NEWS
						<span>
							<i
								className='fa fa-arrow-right'
								style={{ color: "#FF0000" }}
								aria-hidden='true'
							></i>
						</span>
					</Link>
					<Link className='d-flex align-items-center  gap-3'>
						READ FEATURED STORIES
						<span>
							<i
								className='fa fa-arrow-right'
								style={{ color: "#FF0000" }}
								aria-hidden='true'
							></i>
						</span>
					</Link>
				</div>
				<div className='box-container'>
					<div className='box'>
						<div>
							<img src={writing} alt='writing' />
						</div>
						<div>
							<Link>
								<h3>Writing across disciplines: Among elite company</h3>
							</Link>
							<p>
								Iowa's unmatched writing-related resources prepare its graduates for
								success in many fields. This level of excellence positions Iowa as the
								best public university for writing and communication.
							</p>
							<Link className='btnUiowa d-flex align-items-center  gap-3'>
								READ STORY
								<span>
									<i
										className='fa fa-arrow-right'
										style={{ color: "#FF0000" }}
										aria-hidden='true'
									></i>
								</span>
							</Link>
						</div>
					</div>

					<div className='box'>
						<div>
							<img src={research} alt='research' />
						</div>
						<div>
							<Link>
								<h3> Igniting a passion for research and discovery</h3>
							</Link>
							<p>
								Undergraduate students at the University of Iowa not only have plentiful
								opportunities to work alongside faculty researchers, they make important
								contributions to science.
							</p>
							<Link className='btnUiowa d-flex align-items-center  gap-3'>
								READ STORY
								<span>
									<i
										className='fa fa-arrow-right'
										style={{ color: "#FF0000" }}
										aria-hidden='true'
									></i>
								</span>
							</Link>
						</div>
					</div>

					<div className='box'>
						<div>
							<img src={twins} alt='twins' />
						</div>
						<div>
							<Link>
								<h3>Trusting the process, a step at a time</h3>
							</Link>
							<p>
								When twins Noelle and Blaire McDaniel's clubfoot treatment proved a bit
								tricky, their parents never lost faith in their UI Stead Family
								Children's Hospital team, or the revolutionary approach developed at
								Iowa.
							</p>
							<Link className='btnUiowa d-flex align-items-center  gap-3'>
								READ STORY
								<span>
									<i
										className='fa fa-arrow-right'
										style={{ color: "#FF0000" }}
										aria-hidden='true'
									></i>
								</span>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default News;
